import { gql } from "@apollo/client";

export const GET_FINANCIAL_DAILY = gql`
  query vendor_payouts_financial($where: reports_financial_bool_exp) {
    reports_financial(where: $where, order_by: { transaction_date: asc }) {
      vendor_id
      vendor_name
      location_id
      location_name
      event_id
      event_name
      transaction_date
      total_gross_sales
      gross_credit_sales
      gross_rfid_sales
      gross_cash_balance_sales
      gross_cash_sales
      gross_token_sales
      gross_promo_balance_sales
      total_tax
      total_tips
      total_discounts
      total_promo_discounts
      total_refunds
      total_transaction_count
      organization_id
    }
  }
`;

export const GET_PRODUCT_MIX = gql`
  query vendor_payouts_product_mix($where: reports_product_mix_bool_exp) {
    reports_product_mix(where: $where, order_by: { pos_name: asc }) {
      pos_name
      description
      vendor_id
      vendor_name
      location_id
      location_name
      event_id
      event_name
      transaction_date
      total_units_sold
      credit_units_sold
      rfid_units_sold
      cash_balance_units_sold
      gross_credit_sales
      gross_rfid_sales
      gross_cash_balance_sales
      total_gross_sales
      total_tax
      total_discounts
    }
  }
`;

export const GET_COMMISSARY_ORDERS = gql`
  query vendor_payouts_commissary($where: order_commissary_bool_exp) {
    order_commissary(where: $where, order_by: { created_at: desc }) {
      id
      vendor_id
      event_id
      status
      notes
      total
      subtotal
      tax
      items
      created_at
    }
  }
`;

export const GET_EVENT = gql`
  query vendor_payouts_event($id: Int!) {
    events_by_pk(id: $id) {
      id
      name
      start_date
      end_date
      organization {
        id
        name
        logo_url
      }
    }
  }
`;

export const GET_VENDORS = gql`
  query vendor_payouts_vendors($where: vendors_bool_exp) {
    vendors(where: $where, order_by: { name: asc }) {
      id
      name
      revenue_share
      flat_fee
      sales_tax_responsible
    }
  }
`;

export const GET_PAYOUT_ADJUSTMENTS = gql`
  query vendor_payouts_adjustments($where: vendor_payout_adjustments_bool_exp!) {
    vendor_payout_adjustments(where: $where, order_by: { created_at: asc }) {
      id
      vendor_id
      event_id
      kind
      amount
      description
      created_at
    }
  }
`;
